<div class="table-container">
  <!-- Desktop Table View -->
  <div class="desktop-view">
    <table class="admin-table">
      <thead>
        <tr>
          <th>Teljes név</th>
          <th>Felhasználónév</th>
          <th>Munkakör</th>
          <th>Email / Telefonszám</th>
          <th>Létrehozás</th>
          <th>Státusz</th>
          <th>Műveletek</th>
        </tr>
      </thead>
      <tbody>
        @for (colleague of colleagues; track colleague.id) {
          <tr>
            <td>{{ colleague.name }}</td>
            <td>{{ colleague.username }}</td>
            <td>{{ colleague.jobNames.join(', ') }}</td>
            <td>
              <div class="contact-info">
                <div class="email">{{ colleague.email }}</div>
                @if (colleague.phone) {
                  <div class="phone">{{ colleague.phone }}</div>
                }
              </div>
            </td>
            <td>{{ colleague.created_at | date:'yyyy.MM.dd' }}</td>
            <td>
              <span class="status-badge" [class]="colleague.is_active ? 'active' : 'inactive'">
                {{ colleague.is_active ? 'Aktív' : 'Inaktív' }}
              </span>
            </td>
            <td>
              <div class="action-buttons">
                <app-edit-icon-button (clicked)="onEdit(colleague)"></app-edit-icon-button>
                <app-delete-icon-button (clicked)="onDelete(colleague.id)"></app-delete-icon-button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Mobile Card View -->
  <div class="mobile-view">
    @for (colleague of colleagues; track colleague.id) {
      <div class="mobile-card">
        <div class="card-header">
          <div class="card-title">
            <mat-icon class="colleague-icon">person</mat-icon>
            <strong>{{ colleague.name }}</strong>
          </div>
          <span class="status-badge" [class]="colleague.is_active ? 'active' : 'inactive'">
            {{ colleague.is_active ? 'Aktív' : 'Inaktív' }}
          </span>
        </div>
        <div class="card-content">
          <!-- Personal Information -->
          <div class="card-section">
            <div class="section-label">Személyes adatok</div>
            <div class="personal-details">
              <div class="username">{{ colleague.username }}</div>
              <div class="creation-date">Létrehozva: {{ colleague.created_at | date:'yyyy.MM.dd' }}</div>
            </div>
          </div>
          <!-- Job Title -->
          <div class="card-section">
            <div class="section-label">Munkakör</div>
            <span>{{ colleague.jobNames.join(', ') }}</span>
          </div>
          <!-- Contact Information -->
          <div class="card-section">
            <div class="section-label">Elérhetőségek</div>
            <div class="contact-info">
              <div class="email">{{ colleague.email }}</div>
              @if (colleague.phone) {
                <div class="phone">{{ colleague.phone }}</div>
              }
              @if (!colleague.phone) {
                <div class="no-phone">Nincs telefonszám</div>
              }
            </div>
          </div>
          <!-- Actions -->
          <div class="card-section">
            <div class="section-label">Műveletek</div>
            <div class="action-buttons">
              <app-edit-icon-button (clicked)="onEdit(colleague)"></app-edit-icon-button>
              <app-delete-icon-button (clicked)="onDelete(colleague.id)"></app-delete-icon-button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
